import type { Answer, EntityProcessInfo } from 'types';
import { buildLanguageState } from './languageState';
import { LoadingState } from './loadingState';
import { buildUserState } from './userState';

export type AppState = ReturnType<typeof buildAppState>;

export function buildAppState() {
	return {
		context: {} as EntityProcessInfo,
		data: {} as { [key: string]: unknown },
		language: buildLanguageState(),
		loading: LoadingState(),
		riskq: [] as Answer[],
		title: '',
		user: buildUserState()
	};
}
